import { render } from "./CompareStats.vue?vue&type=template&id=129f0b0a&scoped=true"
import script from "./CompareStats.vue?vue&type=script&lang=js"
export * from "./CompareStats.vue?vue&type=script&lang=js"

import "./CompareStats.vue?vue&type=style&index=0&id=129f0b0a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129f0b0a"]])

export default __exports__